"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSelectMultipleTags = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var FormFieldContainer_1 = require("./FormFieldContainer");
var style_1 = require("./style");
var mobx_react_1 = require("mobx-react");
var VMultiSelect_1 = require("./VMultiSelect");
var lodash_1 = require("lodash");
var Validators_1 = require("../Validators");
var MultiSelectTag = VMultiSelect_1.VMultiSelect.ofType();
exports.VSelectMultipleTags = (0, mobx_react_1.observer)(function (props) {
    var selectedItem = (0, react_1.useRef)();
    var changed = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(null), activeItem = _a[0], setActiveItem = _a[1];
    var _b = (0, react_1.useState)([]), itemsSelected = _b[0], setItemsSelected = _b[1];
    var disabled = props.disabled, inline = props.inline, fieldState = props.fieldState, id = props.id, labelInfo = props.labelInfo, layer = props.layer, fill = props.fill, noLabel = props.noLabel, fixedInputWidthPx = props.fixedInputWidthPx, margin = props.margin, required = props.required, options = props.options, label = props.label, tagProps = props.tagProps, inputRef = props.inputRef, _c = props.resetOnClose, resetOnClose = _c === void 0 ? true : _c, inputProps = props.inputProps, tooltip = props.tooltip, placeholder = props.placeholder, displayRequired = props.displayRequired, value = props.value, validators = props.validators;
    (0, react_1.useEffect)(function () {
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
    }, [fieldState, validators, required]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var tValue = (_b = (_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) !== null && _a !== void 0 ? _a : value) !== null && _b !== void 0 ? _b : [];
        var newValue = (0, lodash_1.isArray)(tValue) ? tValue : [];
        if (newValue.length !== itemsSelected.length) {
            setItemsSelected(options.filter(function (item) { return newValue.some(function (el) { return el === item.value; }); }));
        }
        else {
            if (newValue.length > 0) {
                var founded = newValue === null || newValue === void 0 ? void 0 : newValue.some(function (item, index) {
                    return itemsSelected.length > index && item !== itemsSelected[index].value;
                });
                if (founded) {
                    setItemsSelected(options.filter(function (item) {
                        return newValue.some(function (el) { return el === item.value; });
                    }));
                }
            }
        }
    }, [fieldState && (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value), value, options]);
    var areItemsEqual = function (itemA, itemB) {
        return itemA.value === itemB.value;
    };
    var renderTag = function (item) { return item.label; };
    var renderItem = function (item, _a) {
        var modifiers = _a.modifiers, handleClick = _a.handleClick;
        if (!modifiers.matchesPredicate) {
            return null;
        }
        var active = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.value) && item.value === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.value);
        return (react_1.default.createElement(core_1.MenuItem, { disabled: props.disabled, active: active, icon: isItemSelected(item) ? 'tick' : 'blank', key: item.value, onClick: handleClick, text: "".concat(item.label), shouldDismissPopover: false }));
    };
    var handleTagRemove = function (_tag, index) {
        deselectItem(index);
    };
    var getSelectedItemIndex = function (item) {
        return itemsSelected.findIndex(function (element) { return JSON.stringify(element) === JSON.stringify(item); });
    };
    var isItemSelected = function (item) {
        return getSelectedItemIndex(item) !== -1;
    };
    var selectItem = function (item) {
        selectItems(item);
    };
    var selectItems = function (itemsToSelect) {
        var newState = __spreadArray(__spreadArray([], itemsSelected, true), [itemsToSelect], false);
        updateFieldState(newState);
    };
    var deselectItem = function (index) {
        var newState = itemsSelected.filter(function (_item, i) { return i !== index; });
        updateFieldState(newState);
    };
    var handleItemSelect = function (item) {
        selectedItem.current = item;
        setActiveItem(item);
        if (!isItemSelected(item)) {
            selectItem(item);
        }
        else {
            deselectItem(getSelectedItemIndex(item));
        }
    };
    var updateFieldState = function (items) {
        var _a, _b;
        if (items === void 0) { items = itemsSelected; }
        var ids = items.map(function (item) { return item.value; });
        (_a = props.fieldState) === null || _a === void 0 ? void 0 : _a.onChange(ids);
        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, ids);
    };
    var handleClear = function () {
        var _a, _b;
        setItemsSelected([]);
        (_a = props.fieldState) === null || _a === void 0 ? void 0 : _a.onChange([]);
        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, []);
    };
    var filterItem = function (query, item, index) {
        var normalizedTitle = item.label.toLowerCase();
        var normalizedQuery = query.toLowerCase();
        return normalizedTitle.indexOf(normalizedQuery) >= 0;
    };
    var initialContent = undefined;
    var clearButton = itemsSelected.length > 0 ? (react_1.default.createElement(core_1.Button, { icon: "cross", className: 'crossButton', minimal: true, onClick: handleClear })) : (undefined);
    var getItems = function () {
        return props.allowOrder
            ? (0, lodash_1.orderBy)(options, ['label'], [props.orderDirection || false])
            : options;
    };
    var clearActive = function () {
        setActiveItem(null);
        changed.current = true;
    };
    return (react_1.default.createElement(style_1.StyledPopOverWrapper, { disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, fixedInputWidthPx: fixedInputWidthPx, margin: margin },
        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
            react_1.default.createElement(MultiSelectTag, __assign({ activeItem: activeItem, onActiveItemChange: function (item) {
                    if (!changed.current) {
                        if (selectedItem.current) {
                            setActiveItem(selectedItem.current);
                            selectedItem.current = null;
                        }
                        changed.current = true;
                    }
                    else {
                        changed.current = false;
                    }
                }, itemPredicate: filterItem, placeholder: placeholder || '', openOnKeyDown: false, resetOnSelect: true, itemRenderer: renderItem, itemsEqual: areItemsEqual, items: getItems(), noResults: react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." }), onItemSelect: handleItemSelect, popoverProps: {
                    minimal: true,
                    onClose: function () {
                        selectedItem.current = null;
                        changed.current = false;
                        setActiveItem(null);
                    },
                    onOpening: clearActive,
                    onClosing: clearActive
                }, tagRenderer: renderTag, tagInputProps: {
                    disabled: disabled,
                    tagProps: tagProps,
                    inputRef: inputRef,
                    inputProps: inputProps,
                    onRemove: (!props.disabled && handleTagRemove) || (function () { }),
                    rightElement: (!props.disabled && clearButton) || react_1.default.createElement(react_1.default.Fragment, null)
                }, selectedItems: itemsSelected }, { initialContent: initialContent, resetOnClose: resetOnClose })))));
});
